import React from 'react'
import css from './style.css'
import Modal from '../modal'
import Header from '../header'
import Input from '../input'
import Label from '../label'
import Checkbox from '../checkbox'
import Button from '../button'
import { Grid, GridItem } from '../grid'
import { isEmail } from '../../utils'

const SessionModal = props => (
  <Modal isOpen={props.isOpen} onRequestClose={props.onRequestClose} short center>
    <Header subtitle="Select the recipients for this session's details.">
      Email Session Details
    </Header>
    <div className={css.inputs}>
      <InputBlock label='Admin Email' name='admin' value={props.values.admin} onChange={props.onFieldChange} disabled={isProduction()} />
      <InputBlock label='Consultant Email' name='salesRep' value={props.values.salesRep} onChange={props.onFieldChange} disabled={isProduction()} />
      <InputBlock showCheckbox label='Client Email' name='customer' value={props.values.customer} onChange={props.onFieldChange} />
    </div>
    <Button onClick={props.onClick} disabled={props.sendSummaryRequested || props.sendSummarySuccess || !validRecipient(props.values) || !props.clientProfileComplete} center>Email Details</Button>
    {props.sendSummarySuccess && <div className={css.msg}>Thank you, your email will arrive shortly.</div>}
    {props.sendSummaryFail && <div className={[css.error, css.msg].join(' ')}>Something went wrong, please try your request again.</div>}
    {!props.clientProfileComplete && <div className={[css.error, css.msg].join(' ')}>Please complete the Client Profile before finishing your session.</div>}
  </Modal>
)

// This says: validate the admin & salesRep emails and if you want to send
// an email to the customer, validate the customer's email too
const validRecipient = formValues => (
  (isEmail(formValues.admin.email)) &&
  (isEmail(formValues.salesRep.email)) &&
  (!formValues.customer.send || isEmail(formValues.customer.email))
)

const isProduction = () => process.env.NODE_ENV === 'production'

const InputBlock = props => (
  <Grid>
    <GridItem col='1/10' />
    <GridItem col='9/10'>
      <Label>{props.label}</Label>
    </GridItem>
    <GridItem col='1/10'>
      {props.showCheckbox && <Checkbox
        formBlock
        onChange={props.onChange.bind(this, props.name, 'send')}
        checked={props.value.send} />}
    </GridItem>
    <GridItem col='9/10'>
      <Input
        disabled={props.disabled}
        pad
        placeholder={props.label}
        onChange={props.onChange.bind(this, props.name, 'email')}
        value={props.value.email} />
    </GridItem>
  </Grid>
)

export default SessionModal



// WEBPACK FOOTER //
// ./src/components/session-modal/index.js